import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

// import { ProjectTabActions } from '../actions/projectTab';
// import { ElementTypeActions } from '../actions/elementType';
// import { RelationshipTypeActions } from '../actions/relationshipType';
import { ProjectActions } from '../actions/project';
// import { ReportActions } from '../actions/report';
// import { ElementActions } from '../actions/element';
// import { RelationshipActions } from '../actions/relationship';
// import { ViewActions } from '../actions/view'

const projectActions = getActionIds(ProjectActions);
// const reportActions = getActionIds(ReportActions);
// const projectTabActions = getActionIds(ProjectTabActions);
// const elementTypeActions = getActionIds(ElementTypeActions);
// const elementActions = getActionIds(ElementActions);
// const relationshipActions = getActionIds(RelationshipActions);
// const relationshipTypeActions = getActionIds(RelationshipTypeActions);
// const viewActions = getActionIds(ViewActions);

const initialState = Immutable.fromJS({
  tabs: {
    0: {
      id: null,
      type: 'default'
    },
    // 2: {
    //   id: '2',
    //   type: 'element'
    // }
  },
  // tabsOrderId: 0,
  tabsOrder: [0],
  index: 1,
  activeTabIndex: 0
});

export const projectTabs = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  // [elementActions.clientDeleteElements]: (state, action) => {
  //   let tabs = state.get('tabs');
  //   let tabsOrder = state.get('tabsOrder');
  //   let indexesToRemove = [];
  //   let index = state.get('index');

  //   tabs = tabs.filter((tab) => {
  //     if(tab.get('id')) {
  //       if(action.elementIds.indexOf(tab.get('id')) !== -1) {
  //         indexesToRemove.push(tab.get('tabsOrderId'));
  //         return false;
  //       }
  //     }
  //     return tab;
  //   })

  //   tabsOrder = tabsOrder.filter((tabIndex) => {
  //     if(indexesToRemove.indexOf(tabIndex) !== -1){
  //       index = index - 1;
  //       return false;
  //     }
  //     return true;
  //   })

  //   return state.setIn(['tabs'], tabs)
  //     .setIn(['tabsOrder'], tabsOrder)
  //     .setIn(['index'], index);
  // },

  // [projectTabActions.createTab]: (state, action) => {
  //   let mappedType = action.tabType;

  //   if (hasTab(state, action.id, mappedType)) {
  //     const tabsOrderIndex = state.get('tabs').find(function(index) {
  //       return (index.get('id') === action.id && index.get('type') === action.tabType);
  //     }).get('tabsOrderId');
  //     let tabIndex = state.get('tabsOrder').findIndex(function(index) { return index === tabsOrderIndex});
  //     tabIndex = (tabIndex === -1) ? 0 : tabIndex;

  //     return state.merge({
  //       activeTabIndex: tabIndex
  //     });
  //   }

  //   const currentIndex = state.get('index');
  //   const nextIndex = currentIndex + 1;
  //   const tab = {
  //     [currentIndex]: {
  //       id: action.id ? action.id : null,
  //       type: mappedType,
  //       tabsOrderId: currentIndex
  //     }
  //   };

  //   return state.mergeDeep({
  //     tabs: tab,
  //     tabsOrder: state.get('tabsOrder').push(currentIndex),
  //     index: nextIndex,
  //     activeTabIndex: state.get('tabsOrder').size
  //   });
  // },

  // [projectTabActions.destroyTab]: (state, action) => {
  //   let findKey;

  //   state.get('tabs').find(function(v,k ) {
  //     if(v.get('id') === action.tabId || (v.get('id') == null && v.get('type') === action.tabId)){
  //       findKey = k;
  //     }
  //   })

  //   if(state.getIn(['tabsOrder', state.get('activeTabIndex')]) !== action.currentTabId){
  //     return state.merge({
  //       tabs: findKey ? state.get('tabs').delete(findKey) : state.get('tabs'),
  //       tabsOrder: state.get('tabsOrder').delete(state.get('tabsOrder').findIndex(function(index) { return index === findKey})),
  //       activeTabIndex: state.get('activeTabIndex') >= state.get('tabsOrder').indexOf(action.currentTabId) ? state.get('activeTabIndex') - 1 : state.get('activeTabIndex')
  //     });
  //   } else {
  //     return state.merge({
  //       tabs: findKey ? state.get('tabs').delete(findKey) : state.get('tabs'),
  //       tabsOrder: state.get('tabsOrder').delete(state.get('tabsOrder').findIndex(function(index) { return index === findKey})),
  //       activeTabIndex: state.get('tabsOrder').indexOf(action.currentTabId) - 1 < 1 ? 0 : state.get('tabsOrder').indexOf(action.currentTabId) - 1
  //     });
  //   }

  // },

  // [reportActions.deleteReport.success]: (state, action) => {
  //   let keys = [];
  //   const tabs = state.get('tabs');
  //   let index = state.get('index');
  //   const deletedReportId = action.result.id;

  //   tabs.find(function(v,k ) {
  //     if(v.get('type') === 'report' && v.get('id') === deletedReportId){
  //       keys.push(k);
  //     }
  //   });

  //   let updatedIndex = index - 1;

  //   let updatedTabs = tabs.filter( (v, k) => {
  //     return keys.indexOf(k) === -1;
  //   });

  //   let updatedTabsOrder = state.get('tabsOrder').filter( (v, k) => {
  //     return keys.indexOf(v.toString()) === -1
  //   });

  //   return state.setIn(['tabs'], updatedTabs)
  //     .setIn(['tabsOrder'], updatedTabsOrder)
  //     .setIn(['index'], updatedIndex);
  // },

  // [elementTypeActions.deleteElementType.success]: (state, action) => {
  //   let keys = [];
  //   const tabs = state.get('tabs');
  //   let index = state.get('index');
  //   const deletedElementTypeId = action.result.elementTypeId;

  //   tabs.find(function(v,k ) {
  //     if(v.get('type') === 'element-type' && v.get('id') === deletedElementTypeId){
  //       keys.push(k);
  //     }
  //     // if(v.get('type') == 'element' && deletedElementsArray.indexOf( v.get('id'))){
  //     //   keys.push(k);
  //     // }
  //   });

  //   let updatedIndex = index - 1;

  //   let updatedTabs = tabs.filter( (v, k) => {
  //     return keys.indexOf(k) === -1;
  //   });

  //   let updatedTabsOrder = state.get('tabsOrder').filter( (v, k) => {
  //     return keys.indexOf(v.toString()) === -1
  //   });

  //   return state.setIn(['tabs'], updatedTabs)
  //     .setIn(['tabsOrder'], updatedTabsOrder)
  //     .setIn(['index'], updatedIndex);
  // },

  // [relationshipTypeActions.deleteRelationshipType.success]: (state, action) => {
  //   let keys = [];
  //   const tabs = state.get('tabs');
  //   let index = state.get('index');
  //   const deletedRelationshipTypeId = action.result.relationshipTypeId;

  //   tabs.find(function(v,k ) {
  //     if(v.get('type') === 'relationship-type' && v.get('id') === deletedRelationshipTypeId){
  //       keys.push(k);
  //     }
  //     // if(v.get('type') == 'element' && deletedElementsArray.indexOf( v.get('id'))){
  //     //   keys.push(k);
  //     // }
  //   });

  //   let updatedIndex = index - 1;

  //   let updatedTabs = tabs.filter( (v, k) => {
  //     return keys.indexOf(k) === -1;
  //   });

  //   let updatedTabsOrder = state.get('tabsOrder').filter( (v, k) => {
  //     return keys.indexOf(v.toString()) === -1
  //   });

  //   return state.setIn(['tabs'], updatedTabs)
  //     .setIn(['tabsOrder'], updatedTabsOrder)
  //     .setIn(['index'], updatedIndex);
  // },

  // [relationshipActions.deleteRelationship.success]: (state, action) => {
  //   if(!action.result.closeTab) return state;

  //   let tabs = state.get('tabs');
  //   let tabsOrder = state.get('tabsOrder');
  //   let indexesToRemove = [];
  //   let index = state.get('index');

  //   tabs = tabs.filter((tab) => {
  //     if(tab.get('id')) {
  //       if(action.result.relationship.id.indexOf(tab.get('id')) !== -1) {
  //         indexesToRemove.push(tab.get('tabsOrderId'));
  //         return false;
  //       }
  //     }
  //     return tab;
  //   });

  //   tabsOrder = tabsOrder.filter((tabIndex) => {
  //     if(indexesToRemove.indexOf(tabIndex) !== -1){
  //       index = index - 1;
  //       return false;
  //     }
  //     return true;
  //   });

  //   return state.setIn(['tabs'], tabs)
  //     .setIn(['tabsOrder'], tabsOrder)
  //     .setIn(['index'], index);
  // },

});

// function hasTab(state, id, type) {
//   const tabs = state.get('tabs');
//   const tab = tabs.find((v, k) => {
//     return v.get('type') === type && v.get('id') === id;
//   });

//   return !!tab;
// }

export const currentPageIdSelector = state => {
  const activeTabId = state.projectTabs
    .getIn(['tabsOrder', state.projectTabs.get('activeTabIndex')]);
  return activeTabId ?
    state.projectTabs.getIn(['tabs', activeTabId.toString(), 'id']) : null;
};

export const currentPageTypeSelector = state => {
  const activeTabId = state.projectTabs
    .getIn(['tabsOrder', state.projectTabs.get('activeTabIndex')]);
  return activeTabId ?
    state.projectTabs.getIn(['tabs', activeTabId.toString(), 'type']) : null;
};



// WEBPACK FOOTER //
// ./src/reducers/projectTabs.js